<template>
  <div id="layout">
    <the-navbar />
    <router-view id="page" />
    <the-footer />
  </div>
</template>

<script>
import theNavbar from "@/components/TheNavbar.vue";
import theFooter from "@/components/TheFooter.vue";

export default {
  components: {
    theNavbar,
    theFooter
  }
};
</script>

<style>
#layout {
  @apply min-h-screen;
  @apply flex flex-col;
}

#page {
  @apply flex-grow;
}
</style>
